import { render, staticRenderFns } from "./EventsAdmin.vue?vue&type=template&id=1e4eb4f7&scoped=true&"
import script from "./EventsAdmin.vue?vue&type=script&lang=js&"
export * from "./EventsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4eb4f7",
  null
  
)

export default component.exports